import "./file-upload-input.scss";

window.app.directive("fileUploadInput", [
  function() {
    return {
      restrict: "E",
      scope: {
        ngModel: "=",
        disabled: "@",
        placeholder: "@",
        onSelect: "&",
        accept: "@",
        maxFileSize: "@"
        // multiple: "@" // TODO: maybe support this
      },
      template: (tElement, tAttrs) => {
        tElement.html(require("./file-upload-input.html"));
      },
      controller: [
        "$scope",
        "$element",
        "$state",
        "$utils",
        "toastr",
        function($scope, $element, $state, utils, toastr) {
          $scope.hSize = utils($scope).hSize;

          function handleFileSelect(evt) {
            evt.stopPropagation();
            evt.preventDefault();

            var files = evt.target.files || evt.dataTransfer.files;
            const maxSize = $scope.maxFileSize;
            if (maxSize && files[0].size > maxSize) {
              toastr.error(
                "Maximum allowed file size is " +
                  $scope.hSize(maxSize) +
                  `. File "${files[0].name}" is ` +
                  $scope.hSize(files[0].size) +
                  "."
              );
              return;
            }
            $scope.$apply(() => {
              $scope.ngModel = files[0];
            });
            if ($scope.onSelect) {
              $scope.file = $scope.ngModel;
              $scope.onSelect($scope);
            }
          }

          function handleDragOver(evt) {
            console.log("Drag over", evt);
            evt.stopPropagation();
            evt.preventDefault();
            evt.dataTransfer.dropEffect = "copy";
          }

          // TODO maybe handle this in a better way
          function initUploader() {
            const uploadArea = $element[0].querySelector(".file-upload-area");
            if (!uploadArea) {
              setTimeout(initUploader, 200);
              return;
            }
            uploadArea.addEventListener("dragover", handleDragOver, false);
            uploadArea.addEventListener("drop", handleFileSelect, false);
            const uploadInput = uploadArea.querySelector("input");
            uploadInput.addEventListener("change", handleFileSelect, false);
          }

          initUploader();
        }
      ]
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/file-upload-input/file-upload-input.js